document.addEventListener('DOMContentLoaded', function () {
    /**
     * Manage dropdowns
     */
    const dropdownTriggerBtns = document.querySelectorAll('.vendora-dropdown-btn ');

    dropdownTriggerBtns.forEach(btn => {
        btn.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            const dropdown = btn.nextElementSibling; // Selects the next sibling element, which is the dropdown menu
            if (dropdown && dropdown.classList.contains('vendora-dropdown-menu')) {
                dropdown.classList.toggle('active');

                if (dropdown.classList.contains('active')) {
                    dropdown.style.display = 'block';
                } else {
                    dropdown.style.display = 'none';
                }
            }
        })
    });

    document.addEventListener('click', (e) => {
        /**
         * Close Toast
         */
        if (e.target.hasAttribute('vendora-toast-close')) {
            e.preventDefault();
            e.stopPropagation();
            const toast = e.target.closest('.vendora-toast-container');
            if (toast) {
                toast.style.display = 'none';
                toast.remove();
            }
        }

        /**
         * Close Modal on vendora-modal click but not on modal-content click
         */

        if (e.target.classList.contains('vendora-modal') && !e.target.classList.contains('vendora-modal-content') || e.target.hasAttribute('vendora-modal-close')) {
            e.preventDefault();
            e.stopPropagation();
            const modals = document.querySelectorAll('.vendora-modal');
            if (modals) {
                modals.forEach(modal => {
                    modal.style.display = 'none';
                });

                const backdrop = document.querySelector('.vendora-modal-backdrop');
                if (backdrop) {
                    backdrop.remove();
                }
                document.body.style.overflow = 'initial';
            }
        }

        /**
         * Close dropdown on outside click
         * If the clicked element is not the dropdown itself or the button that triggers the dropdown
         */

        if (!e.target.classList.contains('vendora-dropdown-btn') && !e.target.classList.contains('vendora-dropdown-menu')) {
            const dropdowns = document.querySelectorAll('.vendora-dropdown-menu');
            dropdowns.forEach(dropdown => {
                dropdown.classList.remove('active');
                dropdown.style.display = 'none';
            });
        }
    });

    /**
     * Manage Modal
     */

    const modalTriggerBtns = document.querySelectorAll('[vendora-modal-trigger]');

    const modalBackdrop = `<div class="vendora-modal-backdrop"></div>`;

    modalTriggerBtns.forEach(btn => {
        btn.addEventListener('click', (e) => {
            e.preventDefault();
            const modalId = btn.getAttribute('vendora-modal-trigger');
            const modal = document.querySelector(modalId);
            if (modal) {
                modal.style.display = 'block';
                document.body.style.overflow = 'hidden';

                document.body.appendChild(document.createRange().createContextualFragment(modalBackdrop));
            }
        })
    });
})


const modalBackdrop = `<div class="vendora-modal-backdrop"></div>`;

export class Modal {

    constructor(element) {
        this.element = element;
    }

    open() {
        this.element.style.display = 'block';
        document.body.style.overflow = 'hidden';
        document.body.appendChild(document.createRange().createContextualFragment(modalBackdrop));
    }

    close() {
        this.element.style.display = 'none';
        document.body.style.overflow = 'initial';
        const backdrop = document.querySelector('.vendora-modal-backdrop');
        if (backdrop) {
            backdrop.remove();
        }
    }
}